import { render, staticRenderFns } from "./Pacjenci.vue?vue&type=template&id=54f46b21&scoped=true&"
import script from "./Pacjenci.vue?vue&type=script&lang=js&"
export * from "./Pacjenci.vue?vue&type=script&lang=js&"
import style0 from "./Pacjenci.vue?vue&type=style&index=0&id=54f46b21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f46b21",
  null
  
)

export default component.exports